import { leftMenuItems } from '@components/header/HeaderEnterExit';
import MenuContext from '@context/MenuContext';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Link from 'next/link';
import React, { useContext, useEffect, useRef } from 'react';

import useStyles from './MobileMenu.style';

const MobileMenu: React.FC = () => {
  const menuContext = useContext<MenuContext>(MenuContext);
  const { classes, theme } = useStyles({ open: menuContext.open });
  const { md } = useBreakpoints();
  const scrollRef = useRef();

  useEffect(() => {
    if (menuContext.open) {
      disableBodyScroll(scrollRef.current);
    } else {
      enableBodyScroll(scrollRef.current);
    }

    () => clearAllBodyScrollLocks();
  }, [menuContext.open, scrollRef]);
  
  // Only render on mobile devices
  if (md) {
    return null;
  }
  
  return (
    <div
      className={classes.perspectiveWrapper}
      style={{
        height: 'calc(100vh - 80px)',
        minHeight: 'calc(100vh - 80px)'
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        ref={scrollRef}
        className={classes.wrapper}
        style={{
          backgroundColor: 'white',
          height: '100%',
          minHeight: 'calc(100vh - 80px)'
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={classes.screen}>
          <div style={{ flex: '1 1 100%' }}>
            {leftMenuItems.map((item) => (
              <>
                <Typography
                  key={item.id}
                  variant="h2"
                  component="div"
                  style={{ margin: theme.spacing(5, 0) }}
                >
                  <MuiLink
                    href={item.href}
                  >
                    {item.title}
                  </MuiLink>
                </Typography>
                {item.submenu && (
                <>
                  {item.submenu.map((subItem) => (
                    <Typography
                      key={subItem.id}
                      variant="h3"
                      component="div"
                      style={{ margin: theme.spacing(5, 0) }}
                    >
                      <MuiLink
                        href={subItem.href}
                      >
                        {subItem.title}
                      </MuiLink>
              
                    </Typography>
                  ))}
                </>
                )}
              </>
            ))}
          </div>

          <div>
            <Typography
              variant="h6Alt"
              component="div"
              style={{ margin: theme.spacing(5, 0, 5) }}
            >
              <Link
                href="/my/account"
                style={{ color: theme.palette.common.black }}
              >
                
                Account
                
              </Link>
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
